<template>
  <div>
    <div class="mask"
         @click="none"
         :style="{'display':isShow?'block':'none'}"></div>
    <div class="rel"
         :style="{'display':isShow?'block':'none'}">
      <ul :style="{'top':istop=='Video'?'5.25rem':'1rem'}">
        <li @click="toMore('all')"
            :class="{'active':type==''}"><span>全部</span></li>
        <li @click="toMore(item.egId,item.egName)"
            v-for="item in allList"
            :key="item.egId"
            :class="{'active':type==item.egId}"><span>{{ item.egName }}</span></li>
      </ul>
    </div>

    <div class="search">
      <div class="search_inp">
        <input type="text"
               placeholder="请输入视频名称/讲师姓名"
               v-model="title">
        <div class="searchIcon"
             @click="toMore(type,1)">
          <i class="iconfont">&#xe601;</i>
        </div>

      </div>
      <div class="searchSelect">
        <i class="iconfont"
           @click="showList=!showList">&#xe64b;</i>
        <div class="searchList"
             v-show="showList">
          <ul>
            <li :class="item.isSelect?'activeTab':''"
                v-for="(item,index) in egList"
                @click="egListTab(item,index)"
                :key="item.egList">{{ item.egName }}
            </li>

          </ul>
          <div class="optBtn">
            <span @click="reset">重置</span>
            <span @click="toMore(type,1)">筛选</span>

          </div>

        </div>

      </div>

    </div>
    <ul class='typeWrap'
        v-if="egList.filter(v=>v.isSelect).length">
      <div>分类：</div>
      <li v-for="(item,index) in egList"
          v-show="item.isSelect"
          :key="item.egId"><span>{{ item.egName }}</span>
        <i @click.stop="delList(item,index)"
           class="iconfont">&#xe713;</i></li>
    </ul>
  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import bus from '../bus/index'

export default {
  data() {
    return {
      isShow: false,
      title: '',
      type: '',
      allList: [],
      istop: this.$route.name,
      name: '',
      egList: [],
      showList: false

    }
  },
  props: {
    search: {
      type: Function,
      default: () => {
      }
    }
  },

  methods: {
    delList(res, index) {
      let item = res;
      item.isSelect = false
      this.$set(this.egList, index, item)
      /*setTimeout(() => {
        this.toMore()

      }, 500)*/

    },
    reset() {

      this.egList.map((item, index) => {
        item.isSelect = false
        this.$set(this.egList, index, item)
      })
      this.title = '';
    },
    egListTab(res, index) {
      let item = res;
      item.isSelect = !item.isSelect
      this.$set(this.egList, index, item)
    },
    getEngList() {
      this.$postHttp(AppSetting.baseUrl + '/common/entgroup/info', {}).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.list;
          this.egList = data
          this.egList.map((item) => {
            item.isSelect = false

          })


        }

      })
    },
    toMore(type, name) {
      if ((typeof type) == 'number') {
        this.type = type;
        if (name != 1) {
          this.title = '';
          document.title = name;
        }
      } else if (type == 'all') {
        this.type = '';
        this.title = '';
        document.title = '全部';
      }

      let eglist = this.egList.filter(v => v.isSelect)
      let eg_ids = []
      if (eglist.length) {
        eglist.map(item => {
          eg_ids.push(item.egId)
        })

      }
      this.showList = false

      let params = {
        title: this.title,
        type: this.type,
        order: "",
        eg_ids: eg_ids
      };

      console.log(params)

      this.$emit('search', params)
      //this.search && this.search(params);

      this.none();
    },
    none() {
      this.isShow = false;
    },
    screenOut() {
      this.isShow = !this.isShow;
    },
  },

  computed: {},
  mounted() {
    this.getEngList()
  }
}
</script>
<style scoped lang="scss">
.typeWrap {
  font-size: 0.2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #f7f7f7;
  padding: 0 0.3rem 0.1rem;

  li {
    border: 1px solid #007eff;
    border-radius: 1rem;
    margin-right: 0.2rem;
    padding: 1px 5px;
    background: #fff;
    color: #007eff;
    margin-bottom: 5px;

    .iconfont {
      font-size: 0.18rem;
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  font-size: 0.24rem;
  background: rgba(0, 0, 0, 0.5);
}

.rel {
  font-size: 0.28rem;

  ul {
    width: 6.9rem;
    /*height: 3.57rem;*/
    background: #ffffff;
    top: 1.21rem;
    position: absolute;
    left: 0.32rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0.1rem 0.3rem;
    box-sizing: border-box;
    z-index: 11;

    li {
      height: 0.6rem;
      display: flex;
      align-items: center;
      /*vertical-align: center;*/
    }

    li:hover {
      color: rgba(0, 126, 255, 1);
    }
  }
}

#pos {
  top: 4.21rem;
}

.active {
  color: rgba(0, 126, 255, 1);
}

.search {
  width: 100%;

  background: #f7f7f7;
  display: flex;
  align-items: center;
  padding: 0.2rem 0.3rem 0.1rem;
  box-sizing: border-box;

  .search_inp {
    width: 4.8rem;
    height: 0.7rem;
    border: 1px solid #dbdbdb;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background: #ffffff;
    display: flex;
    align-items: center;

    width: 100%;

    input {
      // width:4.21rem;

      display: inline-block;
      width: 100%;
      border: none;
      padding-left: 0.21rem;
      box-sizing: border-box;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      outline: none;
      font-size: 0.28rem;
      height: 0.7rem;
    }

    input::placeholder {
      font-size: 0.28rem;
    }

    .searchIcon {
      width: 1.2rem;
      height: 0.7rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-left: 1px solid #dbdbdb;
      color: #1b94f5;

      i {
        font-size: 0.34rem;
      }
    }
  }

  .searchSelect {
    width: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .iconfont {
      font-size: 0.5rem;
      margin-left: 0.2rem;
      color: #1b94f5;
    }

    .searchList {
      position: absolute;
      width: 3.6rem;
      height: 5rem;
      font-size: 0.3rem;
      top: 0.8rem;
      right: -0.3rem;
      background: #fff;
      z-index: 1000;
      text-align: center;
      box-shadow: #1b94f5;

      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.6);
      border-radius: 3px;
      overflow: hidden;
      padding: 0.2rem 0.2rem 0 0.2rem;

      ul {
        height: 4.18rem;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-y: scroll;
      }

      li {
        background: #ededed;

        padding: 0px 0.2rem;
        border-radius: 1rem;
        margin-right: 0.15rem;
        margin-top: 0.25rem;
        padding: 0px 10px;
        font-size: 0.22rem;
      }

      .activeTab {
        background: #087ff8;
        color: #fff;
      }
    }

    .optBtn {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      width: 100%;

      span {
        flex-grow: 1;
        height: 0.8rem;

        &:nth-child(1) {
          background: #dbdbdb;
          line-height: 0.8rem;
        }

        &:nth-child(2) {
          color: #fff;
          background: #087ff8;
          line-height: 0.8rem;
        }
      }
    }
  }

  .search_type {
    width: 1.8rem;
    display: flex;
    font-size: 0.28rem;
    height: 0.7rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    margin-left: 0.29rem;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    z-index: 11;

    span {
      /*display: inline-block;*/
      color: #1b94f5;
      width: 1.2rem;
      height: 0.7rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }

    div {
      width: 0.6rem;
      height: 0.7rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #dbdbdb;

      img {
        width: 0.48rem;
        height: 0.48rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/container/search.vue